import React, { useEffect, useRef, useState } from 'react';
import { HexColorPicker } from "react-colorful";
import '@rc-component/color-picker/assets/index.css';
import './colorPicker.scss';

enum ColorPickerMode {
    Preview = 'preview',
    Select = 'select',
}

interface ColorPickerProps {
    color: string;
    onChange: (color: string) => void;
    style: React.CSSProperties;
    dataTestId?: string;
}

const ColorPickerComponent: React.FC<ColorPickerProps> = ({ 
    color = '#ff6900', 
    onChange = (color: string) => {},
    style = {},
    dataTestId = '',
}) => {
    const [mode, setMode] = useState<string>(ColorPickerMode.Preview);
    const ref = useRef<HTMLInputElement | null>(null);
    
    useEffect(() => {
        function handleClickOutside(event) {
            if (mode === ColorPickerMode.Preview && ref.current && !ref.current.contains(event.target)) {
                setMode(ColorPickerMode.Preview);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);


    return (
        <>
            <div 
                ref={ref}
                style={{
                    width: '30px',
                    height: '30px',
                    padding: '2px',
                    border: '1px solid #999',
                    cursor: 'pointer',
                    ...style,
                }}
                onClick={() => setMode(mode === ColorPickerMode.Select ? ColorPickerMode.Preview : ColorPickerMode.Select)}
                data-testid={dataTestId || null}
            >
                <div style={{
                    width: '24px',
                    height: '24px',
                    backgroundColor: color,
                }} />
            </div>
            {mode === ColorPickerMode.Select ? (
                <div 
                    className="color-picker-container" 
                    ref={ref}
                    data-testid={dataTestId || null}
                >
                    <HexColorPicker 
                        color={color}
                        onChange={onChange} 
                    />
                </div>
            ) : null}
        </>
    );
}

export default ColorPickerComponent;
